// import React, { useState } from 'react';
// import './Footer.css';

// const Footer = () => {
//   const [subscribed, setSubscribed] = useState(false);
//   const [email, setEmail] = useState('');

//   let emailid = "suvtechhorizon.innovate@gmail.com";
//   let phoneNumber = '+91 98600 00787 | +91 93072 64451';
//   let address = 'Plot No: 34, 2nd Floor, Dattatray Nagar, Beside Axis Bank, Nagpur';

//   const handleSubscribe = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await fetch(`${process.env.REACT_APP_API_URL}/subscribe`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ email }),
//       });
//       if (response.ok) {
//         setSubscribed(true);
//         setTimeout(() => setSubscribed(false), 3000); // Reset subscription state after 3 seconds
//       } else {
//         console.error('Failed to subscribe');
//       }
//     } catch (error) {
//       console.error('Error:', error);
//     }
//   };

//   return (
//     <footer className="footer">
//       <div className="footer-content">
//         <div className="footer-section">
//           <h3>Contact Info</h3>
//           <p>Email: {emailid}</p>
//           <p>Phone: {phoneNumber}</p>
//           <p>Address: {address}</p>
//         </div>
//         <div className="footer-section">
//           <h3>Subscribe to Newsletter</h3>
//           <form className="subscribe-form" onSubmit={handleSubscribe}>
//             <input
//               type="email"
//               placeholder="Enter your email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               required
//             />
//             <button type="submit">Subscribe</button>
//             {subscribed && <p className="form-feedback">Thank you for subscribing!</p>}
//           </form>
//         </div>
//       </div>
//       <div className="footer-bottom">
//         <p>&copy; 2025 CurioSpark Technologies. All rights reserved.</p>
//       </div>
//     </footer>
//   );
// };

// export default Footer;

import React, { useState } from 'react';
import './Footer.css';
import RoomIcon from '@mui/icons-material/Room';
// import './LocationIcon.css';

const Footer = () => {
  const [subscribed, setSubscribed] = useState(false);
  const [email, setEmail] = useState('');

  const emailid = 'director@curiosparktechnologies.com';
  const phoneNumber = '+91 98600 00787 | +91 93072 64451';
  const address = 'Plot No: 34, 2nd Floor, Dattatray Nagar, Beside Axis Bank, Nagpur';
  const mapsLink = 'https://www.google.com/maps/place/CURIOSPARK+TECHNOLOGIES+PRIVATE+LIMITED+%7C+Best+IT+Training+and+Placement+Assistance+in+Nagpur/@21.1179401,79.1156203,17z/data=!3m1!4b1!4m6!3m5!1s0x3bd4b9d74efd389f:0xc521f53824dc395f!8m2!3d21.1179401!4d79.1156203!16s%2Fg%2F11wtpf684_?entry=ttu&g_ep=EgoyMDI1MDYwNC4wIKXMDSoASAFQAw%3D%3D';

  const handleSubscribe = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/subscribe`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });
      if (response.ok) {
        setSubscribed(true);
        setTimeout(() => setSubscribed(false), 3000);
      } else {
        console.error('Failed to subscribe');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>📞 Contact Info</h3>
          <p><strong>Email:</strong> {emailid}</p>
          <p><strong>Phone:</strong> {phoneNumber}</p>
          <p>
            <strong>Address:</strong> {address}{' '}
            <a
              href={mapsLink}
              target="_blank"
              rel="noopener noreferrer"
              title="View on Google Maps"
              className="location-link"
            >
              <RoomIcon className="animated-location-icon" />
            </a>
          </p>
        </div>

        <div className="footer-section">
          <h3>📬 Subscribe to Newsletter</h3>
          <form className="subscribe-form" onSubmit={handleSubscribe}>
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit">Subscribe</button>
            {subscribed && (
              <p className="form-feedback">🎉 Thank you for subscribing!</p>
            )}
          </form>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2025 <strong>CurioSpark Technologies</strong>. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
